import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { ExpensionStepProps } from 'src/shared/ExpensionStepper'
import { Grid } from '@material-ui/core'
import TunnelActions from 'src/shared/TunnelActions/TunnelActions'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { CtxCotationRequest, withCotationRequest } from '../CotationRequestProvider'
import autobind from 'autobind-decorator'
import ChartContext from 'src/shared/Cotation/chart/ChartContext'

import { AUTOCALL_RENDEMENT_data } from 'src/shared/Cotation/chart/data/AutocallRendement'
import { COLLAR_KI_KO_data } from 'src/shared/Cotation/chart/data/CollarKIKO'
import { WEDDING_CAKE_OPTIONS_data } from 'src/shared/Cotation/chart/data/WeddingCakeOptions'
import { TUNNEL_ASYMETRIQUE_data } from 'src/shared/Cotation/chart/data/TunnelAsymetrique'
import { TERME_ASYMETRIQUE_data } from 'src/shared/Cotation/chart/data/TermeAsymetrique'
import { TERME_PARTICIPATIF_ASYMETRIQUE_data } from 'src/shared/Cotation/chart/data/TermeParticipatifAsymetrique'
import { TERME_ASYMETRIQUE_DESACTIVANT_data } from 'src/shared/Cotation/chart/data/TermeAsymetriqueDesactivant'
import { TERME_ACCUMULATEUR_KO_data } from 'src/shared/Cotation/chart/data/TermeAccumulateurKO'
import { TARF_data } from 'src/shared/Cotation/chart/data/TARF'
import { WEDDING_CAKE_ACCUMULATEUR_data } from 'src/shared/Cotation/chart/data/WeddingCakeAccumulateur'
import { SWAP_data } from 'src/shared/Cotation/chart/data/Swap'
import { CAP_data } from 'src/shared/Cotation/chart/data/Cap'
import { COLLAR_data } from 'src/shared/Cotation/chart/data/Collar'
import { SWAP_KO_data } from 'src/shared/Cotation/chart/data/SwapKO'
import { CAP_KO_data } from 'src/shared/Cotation/chart/data/CapKO'
import { COLLAR_KO_data } from 'src/shared/Cotation/chart/data/CollarKO'
import { TERME_SEC_data } from 'src/shared/Cotation/chart/data/TermeSec'


interface IProps extends WithI18n, 
  ReturnType<typeof state2props>,
  CtxCotationRequest,
  ExpensionStepProps{
}

class GraphicVisualizationStep extends React.Component<IProps, {}> {

  render() {
    const {formParams, productSelected} = this.props
    return (
      <>
        {productSelected && formParams && 
          <Grid container>
            <Grid item xs={12}>
              <ChartContext data={this.generateChartAvaiable()} withDescribe={true} isDefault={true}/>
            </Grid>
            <Grid item xs={12}>
              <TunnelActions
                  {...this.props}
                  onClick={this.props.next}
                  canNext={true}
                />
            </Grid>
          </Grid>
        }
      </>
    )
  }

  @autobind
  private generateChartAvaiable(){
      const {formParams, productSelected} = this.props
      if(formParams){
          switch(productSelected!.product_type){
            case 'COLLAR_KI_KO':
              return COLLAR_KI_KO_data(formParams).filter(d => d.isAvailable === true)
            case 'AUTOCALL_RENDEMENT':
                return AUTOCALL_RENDEMENT_data(formParams).filter(d => d.isAvailable === true)
            case 'WEDDING_CAKE_OPTIONS': 
                return WEDDING_CAKE_OPTIONS_data(formParams).filter(d => d.isAvailable === true)
            case 'TUNNEL_ASYMETRIQUE':
                return TUNNEL_ASYMETRIQUE_data(formParams).filter(d => d.isAvailable === true)
            case 'TERME_PARTICIPATIF':
                return TERME_PARTICIPATIF_ASYMETRIQUE_data(formParams).filter(d => d.isAvailable === true)
            case 'TERME_ASYMETRIQUE':
                return TERME_ASYMETRIQUE_data(formParams).filter(d => d.isAvailable === true)
            case 'TERME_ASYMETRIQUE_DESACTIVANT':
                return TERME_ASYMETRIQUE_DESACTIVANT_data(formParams).filter(d => d.isAvailable === true)
            case 'TERME_ACCUMULATEUR_KO':
                return TERME_ACCUMULATEUR_KO_data(formParams).filter(d => d.isAvailable === true)
            case 'TERME_SEC':
                return TERME_SEC_data(formParams).filter(d => d.isAvailable === true)
            case 'TARF':
                return TARF_data(formParams).filter(d => d.isAvailable === true)
            case 'WEDDING_CAKE_ACCUMULATEUR':
                return WEDDING_CAKE_ACCUMULATEUR_data(formParams).filter(d => d.isAvailable === true)
            case 'SWAP':
                return SWAP_data(formParams).filter(d => d.isAvailable === true)
            case 'CAP':
                return CAP_data(formParams).filter(d => d.isAvailable === true)
            case 'COLLAR':
                return COLLAR_data(formParams).filter(d => d.isAvailable === true)
            case 'SWAP_KO':
                return SWAP_KO_data(formParams).filter(d => d.isAvailable === true)
            case 'CAP_KO':
                return CAP_KO_data(formParams).filter(d => d.isAvailable === true)
            case 'COLLAR_KO':
                return COLLAR_KO_data(formParams).filter(d => d.isAvailable === true)
            case 'DIY_PLACEMENT':
                return undefined;
            case 'DIY_CHANGE':
                return undefined;
            default:
                return "";
          }
      } else {
          return undefined;
      }
  }
}

const state2props = (state: RootState) => ({
  product: state.productDetail.entity,
})

export default compose(
    withI18n,
    withCotationRequest,
    connect(state2props, undefined)
)(GraphicVisualizationStep)



// WEBPACK FOOTER //
// ./src/page/Consumer/Product/cotation/step/GraphicVisualizationStep.tsx